/*
 *
 * GenericModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 05-Mar-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { nullSafe } from 'Utility/globalMethods'
import InformativeISPModal from './InformativeIspModal'
import * as PersonalDataActions from '../../modules/PersonalDataActions'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(PersonalDataActions, dispatch),
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = (state) => ({
  isLoading: nullSafe(() => state.loading.localLoading.update_fiscal_code || state.loading.localLoading.change_email, false),
  primaryAction: nullSafe(() => state.popup.popupInfo.primaryAction, ''),
  data: nullSafe(() => state.popup.popupInfo.data, {})
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(InformativeISPModal)
